import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import Iconify from 'src/components/Iconify';
import { useEditDeploymentRing } from 'src/hooks/deploymentRing';
import { pagesText } from 'src/constants/pagesText';
import EditDeploymentRingForm from './EditDeploymentRingForm';

const EditDeploymentRingModal = ({ ring, isDefaultRing, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync: editDeploymentRing, isLoading } = useEditDeploymentRing();

  const handleSubmit = async payload => {
    try {
      await editDeploymentRing({ ringId: ring.id, payload });
      enqueueSnackbar('Deployment ring updated.', { variant: 'success', autoHideDuration: 3000 });
      onClose();
    } catch (error) {
      enqueueSnackbar(typeof error === 'string' && error ? error : pagesText.somethingWentWrong, {
        variant: 'error',
        autoHideDuration: 4000,
      });
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundColor: 'background.dialog' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Iconify icon="mdi:shield-edit-outline" width={22} height={22} color="#87C8E0" />
        Edit Deployment Ring
      </DialogTitle>
      <DialogContent>
        <EditDeploymentRingForm
          ring={ring}
          isDefaultRing={isDefaultRing}
          loading={isLoading}
          onCancel={onClose}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

EditDeploymentRingModal.propTypes = {
  ring: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    deferralDays: PropTypes.number,
  }).isRequired,
  isDefaultRing: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default EditDeploymentRingModal;
